import * as React from 'react';

interface Props {
  className: string;
}

const InviteIcon: React.FC<Props> = ({ className }) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.50033 0.5C8.39053 0.5 8.28069 0.529557 8.18131 0.587891L1.12646 4.80827C0.911048 4.93743 0.728659 5.10804 0.583659 5.30387L8.50033 9.1792L16.4162 5.30387C16.2712 5.10804 16.0896 4.93743 15.8742 4.80827L8.81934 0.587891C8.71996 0.529557 8.61012 0.5 8.50033 0.5ZM8.50033 2.16667C8.84533 2.16667 9.12533 2.44667 9.12533 2.79167V4.04167H10.3753C10.7203 4.04167 11.0003 4.32167 11.0003 4.66667C11.0003 5.01167 10.7203 5.29167 10.3753 5.29167H9.12533V6.54167C9.12533 6.88667 8.84533 7.16667 8.50033 7.16667C8.15533 7.16667 7.87533 6.88667 7.87533 6.54167V5.29167H6.62533C6.28033 5.29167 6.00033 5.01167 6.00033 4.66667C6.00033 4.32167 6.28033 4.04167 6.62533 4.04167H7.87533V2.79167C7.87533 2.44667 8.15533 2.16667 8.50033 2.16667ZM0.166992 6.51644V12.7917C0.166992 14.2833 1.38366 15.5 2.87533 15.5H14.1253C15.617 15.5 16.8337 14.2833 16.8337 12.7917V6.51644L8.77539 10.4373C8.68789 10.479 8.59199 10.5 8.50033 10.5C8.40866 10.5 8.31276 10.479 8.22526 10.4373L0.166992 6.51644Z"
      fill="#187A90"
    />
  </svg>
);
export default InviteIcon;
